import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { Device } from 'src/app/_provider/devices/device.type';
import { DevicesService } from 'src/app/_provider/devices/devices.service';

@Component({
    selector: 'app-device-detail',
    templateUrl: './device-detail.component.html',
    styleUrls: ['./device-detail.component.scss'],
    standalone: false
})
export class DeviceDetailComponent implements OnInit {

  public device: Device
  public attachmentId: number
  public isLoading: boolean = true

  constructor(
    private deviceSrv: DevicesService,
    private popoverCtrl: PopoverController
  ) { }

  async ngOnInit() {
    const deviceResult: HttpFunctionResult<Device> = await this.deviceSrv.getDeviceById(this.attachmentId)
    if(!deviceResult.success) return this.popoverCtrl.dismiss()

    this.isLoading = false
    this.device = deviceResult.data
  }

}
